// react
import React from 'react';

// third-party
import classNames from 'classnames';
import PropTypes from 'prop-types';

// application
import AppLink from '../shared/AppLink';
import Collapse from '../shared/Collapse';

import { ArrowRoundedRight6x9Svg } from '../../svg';

function SubMenuList(props) {
    const {
        layout,
        withIcons,
        items,
        onClick,
    } = props;

    const renderLink = (item, content) => {
        let link;

        if (item.url && item.otherSource === false) {
            link = (
                <AppLink
                    className="colum-sub-content level-2-sub"
                    {...item.props}
                    to={item.url}
                    onClick={() => onClick(item)}
                >
                    {content}
                </AppLink>
            );
        } else if (item.url && item.otherSource === true) {
            link = (
                <a href={item.url} target={item.targeti}>
                    <span>
                        {item.pageName}
                    </span>
                </a>
            );
        } else {
            link = <button type="button" onClick={() => onClick(item)}>{content}</button>;
        }

        return link;
    };

    const itemsList = items.map((item, index) => {
        const renderCategory = (
            {
                setItemRef, setContentRef,
            },
        ) => {
            let expander;
            let arrow;
            let submenu;
            let icon;

            if (item.submenu && item.submenu.length) {
                expander = <ArrowRoundedRight6x9Svg width="20px" height="20px" className="widget-categories__arrow" />;
            //     // arrow = <ArrowRoundedRight6x9Svg className="menu__arrow" />;
            }

            if (item.submenu && item.submenu.length) {
                submenu = (
                    <div className="menu__submenu" ref={setContentRef}>
                        <SubMenuList items={item.submenu} onClick={() => onClick(item)} />
                    </div>
                );
            }

            if (withIcons && item.icon) {
                icon = (
                    <div className="menu__icon">
                        <img src={item.icon} srcSet={item.icon_srcset} alt="" />
                    </div>
                );
            }

            return (
                <div className="colum-box" key={index} ref={setItemRef}>
                    <div className="col-md-12 colum-sub-content">
                        {renderLink(item, (
                            <React.Fragment>
                                {icon}
                                {/* {item.title} */}
                                {item.pageName}
                                {arrow}
                            </React.Fragment>
                        ))}
                        {submenu}
                        <div className="arrow-subchild">
                            {expander}
                        </div>
                    </div>

                </div>
            );
        };
        return <Collapse key={index} toggleClass="menu__item--open-sub" render={renderCategory} />;
    });

    const classes = classNames(`menu-full menu-full--layout--${layout}`, {
        'menu--with-icons': withIcons,
    });

    return (
        <div className={classes}>
            <div className="level-3-childs">
                {itemsList}
            </div>
        </div>
    );
}

SubMenuList.propTypes = {
    /** one of ['classic', 'topbar'] (default: 'classic') */
    layout: PropTypes.oneOf(['classic', 'topbar']),
    /** default: false */
    withIcons: PropTypes.bool,
    /** array of menu items */
    items: PropTypes.array,
    /** callback function that is called when the item is clicked */
    onClick: PropTypes.func,
};

SubMenuList.defaultProps = {
    layout: 'classic',
    withIcons: false,
    items: [],
    onClick: () => { },
};

export default SubMenuList;
